// commandes.js
let supabase;

export function setSupabaseClient(client) {
    supabase = client;
}

let commandeEnCours = {
    lignes: [],
    total: 0,
    id: null,
    enEdition: false
};

export async function initCommandes() {
    if (!supabase) {
        console.error('Supabase client manquant dans commandes.js');
        return;
    }

    setDefaultDate();
    await loadCommandeFournisseurs();
    await loadCommandeHistory();
    setupCommandeEventListeners();
}

function setDefaultDate() {
    const dateInput = document.getElementById('commande-date');
    const today = new Date().toISOString().split('T')[0];
    dateInput.value = today;
}

async function loadCommandeFournisseurs() {
    try {
        const { data: suppliers, error } = await supabase
            .from('fournisseurs')
            .select('*')
            .order('nom', { ascending: true });

        if (error) throw error;

        const select = document.getElementById('commande-fournisseur');
        select.innerHTML = '<option value="">Sélectionner un fournisseur...</option>';

        if (suppliers) {
            suppliers.forEach(supplier => {
                const option = document.createElement('option');
                option.value = supplier.nom;
                option.textContent = supplier.nom;
                select.appendChild(option);
            });
        }
    } catch (err) {
        console.error('Erreur chargement fournisseurs:', err);
    }
}

function setupCommandeEventListeners() {
    document.getElementById('commande-fournisseur').addEventListener('change', updateCommandeProduits);
    document.getElementById('annuler-commande').addEventListener('click', annulerCommande);
    document.getElementById('sauvegarder-brouillon').addEventListener('click', () => sauvegarderCommande('brouillon'));
    document.getElementById('envoyer-commande').addEventListener('click', () => sauvegarderCommande('envoyée'));
    document.getElementById('btn-ajouter-produit-manuel').addEventListener('click', afficherFormulaireProduitManuel);
    document.getElementById('annuler-produit-manuel').addEventListener('click', cacherFormulaireProduitManuel);
    document.getElementById('valider-produit-manuel').addEventListener('click', ajouterProduitManuel);
}

function afficherFormulaireProduitManuel() {
    document.getElementById('form-produit-manuel').style.display = 'block';
}

function cacherFormulaireProduitManuel() {
    document.getElementById('form-produit-manuel').style.display = 'none';
    document.getElementById('produit-manuel-nom').value = '';
    document.getElementById('produit-manuel-carton').value = '6';
    document.getElementById('produit-manuel-prix').value = '';
    document.getElementById('produit-manuel-quantite').value = '1';
}

function ajouterProduitManuel() {
    const nom = document.getElementById('produit-manuel-nom').value.trim();
    const carton = parseInt(document.getElementById('produit-manuel-carton').value);
    const prix = parseFloat(document.getElementById('produit-manuel-prix').value);
    const quantite = parseInt(document.getElementById('produit-manuel-quantite').value);

    if (!nom || !carton || !prix || !quantite) {
        showToast('Veuillez remplir tous les champs', 'warning');
        return;
    }

    const tbody = document.getElementById('commande-produits-tbody');
    const row = document.createElement('tr');
    row.classList.add('produit-manuel');

    const uniqueId = `manuel-${Date.now()}`;

    row.innerHTML = `
        <td>${nom}</td>
        <td>${carton}</td>
        <td>${prix.toFixed(2)} €</td>
        <td>
            <input
                type="number"
                min="0"
                value="${quantite}"
                class="quantite-input"
                data-product-id="${uniqueId}"
                data-product-name="${nom}"
                data-product-price="${prix}"
                data-is-manual="true"
                style="width: 100px; padding: 6px; border: 1px solid #e2e8f0; border-radius: 4px;"
            />
        </td>
        <td>
            <button class="btn-delete" onclick="window.supprimerLigneProduitManuel(this)">🗑️</button>
        </td>
    `;

    tbody.appendChild(row);

    const input = row.querySelector('.quantite-input');
    input.addEventListener('input', calculerTotalCommande);

    calculerTotalCommande();
    cacherFormulaireProduitManuel();
    showToast('Produit ajouté à la commande');
}

window.supprimerLigneProduitManuel = (button) => {
    if (confirm('Voulez-vous supprimer ce produit de la commande ?')) {
        button.closest('tr').remove();
        calculerTotalCommande();
        showToast('Produit supprimé');
    }
};

async function updateCommandeProduits() {
    const fournisseur = document.getElementById('commande-fournisseur').value;
    const container = document.getElementById('commande-produits-container');
    const tbody = document.getElementById('commande-produits-tbody');

    if (!fournisseur) {
        container.style.display = 'none';
        commandeEnCours.lignes = [];
        commandeEnCours.total = 0;
        return;
    }

    try {
        const { data: products, error } = await supabase
            .from('produits')
            .select('*')
            .eq('fournisseur', fournisseur)
            .order('nom_produit', { ascending: true });

        if (error) throw error;

        tbody.innerHTML = '';

        if (products && products.length > 0) {
            container.style.display = 'block';

            products.forEach(product => {
                const row = document.createElement('tr');
                row.innerHTML = `
                    <td>${product.nom_produit}</td>
                    <td>${product.carton}</td>
                    <td>${parseFloat(product.pa_eur).toFixed(2)} €</td>
                    <td>
                        <input
                            type="number"
                            min="0"
                            value="0"
                            class="quantite-input"
                            data-product-id="${product.id}"
                            data-product-name="${product.nom_produit}"
                            data-product-price="${product.pa_eur}"
                            style="width: 100px; padding: 6px; border: 1px solid #e2e8f0; border-radius: 4px;"
                        />
                    </td>
                    <td></td>
                `;
                tbody.appendChild(row);
            });

            const inputs = tbody.querySelectorAll('.quantite-input');
            inputs.forEach(input => {
                input.addEventListener('input', calculerTotalCommande);
            });
        } else {
            container.style.display = 'none';
            showToast('Aucun produit disponible pour ce fournisseur', 'warning');
        }
    } catch (err) {
        console.error('Erreur chargement produits:', err);
        showToast('Erreur lors du chargement des produits', 'error');
    }
}

function calculerTotalCommande() {
    const inputs = document.querySelectorAll('.quantite-input');
    let total = 0;

    commandeEnCours.lignes = [];

    inputs.forEach(input => {
        const quantite = parseInt(input.value) || 0;
        if (quantite > 0) {
            const productId = input.dataset.productId;
            const nomProduit = input.dataset.productName;
            const prixUnitaire = parseFloat(input.dataset.productPrice);
            const totalLigne = prixUnitaire * quantite;

            commandeEnCours.lignes.push({
                produitId: productId,
                nomProduit: nomProduit,
                quantite: quantite,
                prixUnitaire: prixUnitaire,
                total: totalLigne
            });

            total += totalLigne;
        }
    });

    commandeEnCours.total = total;
    document.getElementById('commande-total').textContent = total.toFixed(2);
}

function annulerCommande() {
    if (commandeEnCours.lignes.length > 0) {
        if (!confirm('Êtes-vous sûr de vouloir annuler cette commande ?')) return;
    }

    commandeEnCours = {
        lignes: [],
        total: 0,
        id: null,
        enEdition: false
    };

    const fournisseurSelect = document.getElementById('commande-fournisseur');
    fournisseurSelect.value = '';
    fournisseurSelect.disabled = false;

    document.getElementById('commande-notes').value = '';
    document.getElementById('commande-produits-container').style.display = 'none';
    document.getElementById('commande-total').textContent = '0.00';
    document.getElementById('form-produit-manuel').style.display = 'none';

    const modeEditionIndicator = document.getElementById('mode-edition-indicator');
    if (modeEditionIndicator) {
        modeEditionIndicator.remove();
    }

    setDefaultDate();
}

async function sauvegarderCommande(statut) {
    const fournisseur = document.getElementById('commande-fournisseur').value;
    const dateCommande = document.getElementById('commande-date').value;
    const notes = document.getElementById('commande-notes').value;

    if (!fournisseur) {
        showToast('Veuillez sélectionner un fournisseur', 'warning');
        return;
    }

    if (commandeEnCours.lignes.length === 0) {
        showToast('Veuillez ajouter au moins un produit', 'warning');
        return;
    }

    try {
        let commande;

        if (commandeEnCours.enEdition && commandeEnCours.id) {
            const { data, error: commandeError } = await supabase
                .from('commandes')
                .update({
                    fournisseur,
                    date_commande: dateCommande,
                    statut,
                    total_eur: commandeEnCours.total,
                    notes,
                    updated_at: new Date().toISOString()
                })
                .eq('id', commandeEnCours.id)
                .select()
                .single();

            if (commandeError) throw commandeError;
            commande = data;

            const { error: deleteError } = await supabase
                .from('commandes_lignes')
                .delete()
                .eq('commande_id', commandeEnCours.id);

            if (deleteError) throw deleteError;
        } else {
            const numeroCommande = await genererNumeroCommande();

            const { data, error: commandeError } = await supabase
                .from('commandes')
                .insert([{
                    numero_commande: numeroCommande,
                    fournisseur,
                    date_commande: dateCommande,
                    statut,
                    total_eur: commandeEnCours.total,
                    notes
                }])
                .select()
                .single();

            if (commandeError) throw commandeError;
            commande = data;
        }

        const lignes = commandeEnCours.lignes.map(ligne => ({
            commande_id: commande.id,
            produit_id: ligne.produitId && !ligne.produitId.startsWith('manuel-') ? ligne.produitId : null,
            nom_produit: ligne.nomProduit,
            quantite: ligne.quantite,
            prix_unitaire: ligne.prixUnitaire,
            total: ligne.total
        }));

        const { error: lignesError } = await supabase
            .from('commandes_lignes')
            .insert(lignes);

        if (lignesError) throw lignesError;

        const action = commandeEnCours.enEdition ? 'modifiée' : statut === 'brouillon' ? 'sauvegardée en brouillon' : 'envoyée';
        showToast(`Commande ${action} avec succès`);
        annulerCommande();
        await loadCommandeHistory();
    } catch (err) {
        console.error('Erreur sauvegarde commande:', err);
        showToast('Erreur lors de la sauvegarde de la commande', 'error');
    }
}

async function genererNumeroCommande() {
    const date = new Date();
    const dateStr = date.toISOString().slice(0, 10).replace(/-/g, '');

    const { data, error } = await supabase
        .from('commandes')
        .select('numero_commande')
        .like('numero_commande', `CMD-${dateStr}-%`)
        .order('numero_commande', { ascending: false })
        .limit(1);

    let numero = 1;
    if (data && data.length > 0) {
        const lastNum = data[0].numero_commande.split('-')[2];
        numero = parseInt(lastNum) + 1;
    }

    return `CMD-${dateStr}-${numero.toString().padStart(4, '0')}`;
}

async function loadCommandeHistory() {
    try {
        const { data: commandes, error } = await supabase
            .from('commandes')
            .select('*')
            .order('created_at', { ascending: false });

        if (error) throw error;

        const tbody = document.getElementById('commandes-tbody');
        tbody.innerHTML = '';

        if (!commandes || commandes.length === 0) {
            tbody.innerHTML = '<tr><td colspan="6" style="text-align: center;">Aucune commande</td></tr>';
            return;
        }

        commandes.forEach(commande => {
            const row = document.createElement('tr');
            const statutClass = getStatutClass(commande.statut);

            row.innerHTML = `
                <td>${commande.numero_commande}</td>
                <td>${commande.fournisseur}</td>
                <td>${new Date(commande.date_commande).toLocaleDateString('fr-FR')}</td>
                <td><span class="statut-badge ${statutClass}">${commande.statut}</span></td>
                <td>${parseFloat(commande.total_eur).toFixed(2)} €</td>
                <td>
                    <button class="btn-edit" onclick="window.voirCommande('${commande.id}')">👁️</button>
                    ${commande.statut === 'brouillon' ? `
                        <button class="btn-edit" onclick="window.modifierCommande('${commande.id}')">✏️</button>
                        <button class="btn-delete" onclick="window.supprimerCommande('${commande.id}')">🗑️</button>
                    ` : ''}
                </td>
            `;
            tbody.appendChild(row);
        });
    } catch (err) {
        console.error('Erreur chargement historique commandes:', err);
    }
}

function getStatutClass(statut) {
    const classes = {
        'brouillon': 'statut-brouillon',
        'envoyée': 'statut-envoyee',
        'reçue': 'statut-recue',
        'annulée': 'statut-annulee'
    };
    return classes[statut] || '';
}

window.voirCommande = async (id) => {
    try {
        const { data: commande, error: commandeError } = await supabase
            .from('commandes')
            .select('*')
            .eq('id', id)
            .single();

        if (commandeError) throw commandeError;

        const { data: lignes, error: lignesError } = await supabase
            .from('commandes_lignes')
            .select('*')
            .eq('commande_id', id);

        if (lignesError) throw lignesError;

        let detailsHTML = `
            N° Commande: ${commande.numero_commande}
            Fournisseur: ${commande.fournisseur}
            Date: ${new Date(commande.date_commande).toLocaleDateString('fr-FR')}
            Statut: ${commande.statut}
            ${commande.notes ? `Notes: ${commande.notes}` : ''}

            Produits:
        `;

        lignes.forEach(ligne => {
            detailsHTML += `- ${ligne.nom_produit}: ${ligne.quantite} × ${parseFloat(ligne.prix_unitaire).toFixed(2)}€ = ${parseFloat(ligne.total).toFixed(2)}€\n`;
        });

        detailsHTML += `\nTotal: ${parseFloat(commande.total_eur).toFixed(2)} €`;

        alert(detailsHTML);
    } catch (err) {
        console.error('Erreur chargement détails commande:', err);
        showToast('Erreur lors du chargement des détails', 'error');
    }
};

window.modifierCommande = async (id) => {
    try {
        const { data: commande, error: commandeError } = await supabase
            .from('commandes')
            .select('*')
            .eq('id', id)
            .single();

        if (commandeError) throw commandeError;

        const { data: lignes, error: lignesError } = await supabase
            .from('commandes_lignes')
            .select('*')
            .eq('commande_id', id);

        if (lignesError) throw lignesError;

        commandeEnCours.id = commande.id;
        commandeEnCours.enEdition = true;

        const fournisseurSelect = document.getElementById('commande-fournisseur');
        fournisseurSelect.value = commande.fournisseur;
        fournisseurSelect.disabled = true;

        document.getElementById('commande-date').value = commande.date_commande;
        document.getElementById('commande-notes').value = commande.notes || '';

        const container = document.getElementById('commande-produits-container');
        const tbody = document.getElementById('commande-produits-tbody');

        const { data: products, error: productsError } = await supabase
            .from('produits')
            .select('*')
            .eq('fournisseur', commande.fournisseur)
            .order('nom_produit', { ascending: true });

        if (productsError) throw productsError;

        tbody.innerHTML = '';

        if (products && products.length > 0) {
            products.forEach(product => {
                const ligneExistante = lignes.find(l => l.produit_id === product.id);
                const quantite = ligneExistante ? ligneExistante.quantite : 0;

                const row = document.createElement('tr');
                row.innerHTML = `
                    <td>${product.nom_produit}</td>
                    <td>${product.carton}</td>
                    <td>${parseFloat(product.pa_eur).toFixed(2)} €</td>
                    <td>
                        <input
                            type="number"
                            min="0"
                            value="${quantite}"
                            class="quantite-input"
                            data-product-id="${product.id}"
                            data-product-name="${product.nom_produit}"
                            data-product-price="${product.pa_eur}"
                            style="width: 100px; padding: 6px; border: 1px solid #e2e8f0; border-radius: 4px;"
                        />
                    </td>
                    <td></td>
                `;
                tbody.appendChild(row);
            });
        }

        const produitsManuel = lignes.filter(l => !l.produit_id);
        produitsManuel.forEach(ligne => {
            const row = document.createElement('tr');
            row.classList.add('produit-manuel');
            const uniqueId = `manuel-${Date.now()}-${Math.random()}`;

            row.innerHTML = `
                <td>${ligne.nom_produit}</td>
                <td>-</td>
                <td>${parseFloat(ligne.prix_unitaire).toFixed(2)} €</td>
                <td>
                    <input
                        type="number"
                        min="0"
                        value="${ligne.quantite}"
                        class="quantite-input"
                        data-product-id="${uniqueId}"
                        data-product-name="${ligne.nom_produit}"
                        data-product-price="${ligne.prix_unitaire}"
                        data-is-manual="true"
                        style="width: 100px; padding: 6px; border: 1px solid #e2e8f0; border-radius: 4px;"
                    />
                </td>
                <td>
                    <button class="btn-delete" onclick="window.supprimerLigneProduitManuel(this)">🗑️</button>
                </td>
            `;
            tbody.appendChild(row);
        });

        const inputs = tbody.querySelectorAll('.quantite-input');
        inputs.forEach(input => {
            input.addEventListener('input', calculerTotalCommande);
        });

        calculerTotalCommande();
        container.style.display = 'block';

        const commandeSection = document.getElementById('section-orders');
        if (commandeSection && !commandeSection.open) {
            commandeSection.open = true;
        }

        const existingIndicator = document.getElementById('mode-edition-indicator');
        if (existingIndicator) {
            existingIndicator.remove();
        }

        const indicator = document.createElement('div');
        indicator.id = 'mode-edition-indicator';
        indicator.style.cssText = 'background: #fef3c7; border: 2px solid #f59e0b; padding: 12px; border-radius: 8px; margin-bottom: 20px; font-weight: bold; color: #92400e;';
        indicator.innerHTML = `✏️ Mode édition - Commande ${commande.numero_commande}`;

        const firstH3 = commandeSection.querySelector('h3');
        if (firstH3) firstH3.insertAdjacentElement('afterend', indicator);

        window.scrollTo({ top: 0, behavior: 'smooth' });

        showToast('Commande chargée pour modification');
    } catch (err) {
        console.error('Erreur chargement commande:', err);
        showToast('Erreur lors du chargement de la commande', 'error');
    }
};

window.supprimerCommande = async (id) => {
    if (!confirm('Êtes-vous sûr de vouloir supprimer cette commande ?')) return;

    try {
        const { error } = await supabase
            .from('commandes')
            .delete()
            .eq('id', id);

        if (error) throw error;

        showToast('Commande supprimée');
        await loadCommandeHistory();
    } catch (err) {
        console.error('Erreur suppression commande:', err);
        showToast('Erreur lors de la suppression', 'error');
    }
};

function showToast(message, type = 'success') {
    const toast = document.getElementById('toast');
    toast.textContent = message;
    toast.className = `toast ${type} show`;
    setTimeout(() => {
        toast.className = 'toast';
    }, 3000);
}
